import { Tabs, Tab } from "react-bootstrap";
import Cuisine from "./Cuisine";
import DeliverySlots from "./DeliverySlots";
import ProfitMargin from "./ProfitMargin";
import Promo from "./Promo";
import ServiceCharges from "./ServiceCharges";

export default function SettingNav() {
  return (
    <Tabs defaultActiveKey="profit_margin">
      <Tab eventKey="profit_margin" title="Profit Margin">
        <ProfitMargin />
      </Tab>
      <Tab eventKey="charges" title="Service Charges">
        <ServiceCharges />
      </Tab>
      <Tab eventKey="cuisine" title="Cuisine">
        <Cuisine />
      </Tab>
      <Tab eventKey="slots" title="Delivery Slots">
        <DeliverySlots />
      </Tab>
      <Tab eventKey="promos" title="Promos">
        <Promo />
      </Tab>
    </Tabs>
  );
}
